import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const ensureTokenRoute = () => {
  if (typeof window === 'undefined' || typeof window.location === 'undefined') {
    return;
  }
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  const alreadyOnGallery = url.pathname.startsWith('/gallery/');
  const alreadyOnFaceSearch = url.pathname.startsWith('/face-search/');
  
  // 如果用户通过链接访问，确保路由正确
  if (token && !alreadyOnGallery && !alreadyOnFaceSearch) {
    const newPath = `/gallery/${token}${url.hash ?? ''}`;
    window.history.replaceState(null, '', newPath);
  }
};

ensureTokenRoute();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);
